import { Activity, BookingOption } from '../../types/Activity';
import LedgerEntry from '../../types/LedgerEntry';

export const mapItemsWithActivityBookingOptions = <
  T extends { id: BookingOption['id'] }
>(
  items: Array<T>,
  activity: Activity
): Array<[T, BookingOption | undefined]> => {
  const activityOptions: Map<BookingOption['id'], BookingOption> = new Map();
  (activity.bookingOptions || []).forEach(option =>
    activityOptions.set(option.id, option)
  );

  const mappedItems: Array<[T, BookingOption | undefined]> = [];
  items.forEach(item => {
    const option = activityOptions.get(item.id);
    mappedItems.push([item, option]);
  });
  return mappedItems;
};

export const getAmountToTransfer = (entry: LedgerEntry): number => {
  const { totalTransferredToVendor, totalPlatformProcessingFee } = entry;
  const totalAmount =
    totalTransferredToVendor.amount + totalTransferredToVendor.taxAmount;
  const totalTransferAmount =
    totalAmount - (totalPlatformProcessingFee?.amount ?? 0);
  return totalTransferAmount;
};
